var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.6154L20.2007 21H3V3H4.38462V19.6154H21ZM7.84615 10.3203V18.2308H9.23077V7.90261L7.84615 10.3203ZM16.1538 10.3212V18.2308H17.5385V7.90349L16.1538 10.3212ZM10.6427 8.94462V18.2308H12.0273V6.52687L10.6427 8.94462ZM13.3846 12.6201V18.2308H14.7692V10.2024L13.3846 12.6201Z",
    fill: "#111113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalysis);
export default __webpack_public_path__ + "static/media/data-analysis.7b13e7cba08f8b06c0f7d2925525eed1.svg";
export { ForwardRef as ReactComponent };